/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Image) GS.Toolbar.Image={};

GS.Toolbar.Image.ColorsTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Image.ColorsTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'l':'Brightness','c':'Contrast','s':'Saturation','enable_color':'Photo color','enable_sepia':'Sepia','enable_bw':'B&W','enable_multiply':'Moltiplica'},
        'toolbar':null
    },
    controlled:null,
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.color_effects');
       this.parent(conf);

    }
});

GS.Toolbar.Image.ColorsTools.prototype.prepareLevelsSelectorNode = function(){
    if(!this.sm) return;
    let container = this.sm.querySelector('[data-type="levels_effect"]');
    if(!container) return;
    let select = container.querySelector('select');
    let values = {
        '':'Normal',
        'multiply':'Multiply',
        'color': 'Color',
        'overlay':'Overlay',
        'exclusion':'Esclusione',
        'hue':'Hue',
        'difference':'Difference',
        'lighten':'Lighten',
        'darken':'Darken',
        'screen':'Screen',
        'color-burn':'Color Burn',
        'color-dodge':'Color Dodge',
        'luminosity':'Luminosity'
    };
    let current_value = this.controlled ? this.controlled.getLevelEffect() : null;
    if(!current_value) current_value = '';
    if(!select){
        select = document.createElement('select');
        select.addEventListener('change', (e) => {
            if(this.controlled && this.controlled.setLevelEffect) this.controlled.setLevelEffect(e.currentTarget.value || null)
        })
        let label = document.createElement('label');
        label.innerText = 'Modalità di fusione'
        container.appendChild(label);
        Object.keys(values).map(function(val){
            let opt = document.createElement('option');
            opt.value = val;
            opt.innerText = values[val];

            select.appendChild(opt);
        });
        container.appendChild(select);
    }

    select.value = current_value;

}

GS.Toolbar.Image.ColorsTools.prototype.updatePermissions = function (p){
    //console.info('IMAGE COLOR TOOLS UPDATE PERMISSION...', p);
    //this.parent(p);

    var sepiaInp, bwInp, satuInp, hueInp, si;

    if(!p.effects){
        //console.warn('I\'AM HERE');
        this.sm.parentNode.style.display = 'none';
    }else{
        this.sm.parentNode.style.display = 'inline-block';
        //this.sm.style.display = 'inline-block';
        sepiaInp = this.sm ? this.sm.querySelector('[data-type="sepia"]') : null;
        bwInp = this.sm ? this.sm.querySelector('[data-type="bw"]') : null;
        satuInp = this.sm ? this.sm.querySelector('[data-type="effect-saturation"]') : null;
        hueInp = this.sm ? this.sm.querySelector('[data-type="effect-hue"]') : null;

        if(sepiaInp) sepiaInp.removeAttribute('hidden');
        if(bwInp) bwInp.removeAttribute('hidden');
        if(satuInp) satuInp.removeAttribute('hidden');
        if(hueInp) hueInp.removeAttribute('hidden');


        if(sepiaInp && p.effects && !p.effects['sepia']) sepiaInp.setAttribute('hidden', true);
        if(bwInp && p.effects && !p.effects['b&w']) bwInp.setAttribute('hidden', true);
        if(satuInp && p.effects && !p.effects['saturation']) satuInp.setAttribute('hidden', true);
        if(hueInp && p.effects && !p.effects['hue']) hueInp.setAttribute('hidden', true);
        this.prepareLevelsSelectorNode();

    }


}


GS.Toolbar.Image.ColorsTools.prototype.menuTMPL=function(){
   //var out=' <li class="on-off" data-uitype="checkbox" data-type="colors-on" title="{tooltip_enable_color}"><label>{enable_color}</label></li>';

    var out = '';

    if(window.getCustomerCode && window.getCustomerCode() === 0) {
        out += '      <li class="separator-h"></li>';
        out += '      <li class="select" data-uitype="select" data-type="levels_effect"></li>';
    }

    out +='   <li class="slider effect-hue" data-type="effect-hue" data-uitype="slider_w_input" title="{tooltip_h}"><label class="min">{hMin}</label><label>{h}</label><label class="max">{hMax}</label></li>';
    out +='      <li class="separator-h"></li>';
        
   /* 
    out+='      <li class="slider effect-brightness" data-type="effect-brightness" data-uitype="slider" title="{tooltip_l}"><label class="min">{lMin}</label><label>{l}</label><label class="max">{lMax}</label></li>';
    out+='      <li class="separetor-h"></li>';
    */
    
    out +='      <li class="slider effect-saturation" data-type="effect-saturation" data-uitype="slider_w_input" title="{tooltip_s}"><label class="min">{sMin}</label><label>{s}</label><label class="max">{sMax}</label></li>';
    out +='      <li class="separator-h"></li>';
    
    /*
    out+='      <li class="slider effect-contrast" data-type="effect-contrast" data-uitype="slider" title="{tooltip_c}"><label class="min">{cMin}</label><label>{c}</label><label class="max">{cMax}</label></li>';
    out+='      <li class="separetor-h"></li>';
    */
    
    out +='      <li class="on-off" data-uitype="checkbox" data-type="sepia" title="{tooltip_enable_sepia}"><label>{enable_sepia}</label></li>';
    out +='      <li class="separator"></li>';
    out +='      <li class="on-off" data-uitype="checkbox" data-type="bw" title="{tooltip_enable_bw}"><label>{enable_bw}</label></li>';


    out +='      <li class="separator-h"></li>';
    out +='      <li class="reset" data-uitype="full-btn" data-type="reset-colors-effects" title="{tooltip_reset}">{reset}</li>';

    /*out+='      <li class="on-off" data-uitype="checkbox" data-type="effect-colorize" title="{tooltip_enable_colorize}"><label>{enable_colorize}</label></li>';
    out+='      <li class="image-color" data-type="image-color"  id="toolbar-image-color" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';*/
    return out;
};